// classes
import Experience from "../Experience";
import Lights from "./Enviroment/Lights"
import Terrain from "./Enviroment/Terrain"
import Fox from "./Fox";

export default class World
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.debug = this.experience.debug
        this.resourceLoader = this.experience.resourceLoader

        // options
        this.lights = new Lights()
        this.resourceLoader.on( "itemsLoaded", () =>
        {
            this.terrain = new Terrain()
            this.fox = new Fox()
        } )
    }

    update()
    {

    }

    setDebug()
    {
        this.worldFolder = this.debug.ui.addFolder( 
        {
            title: "World",
            expanded: false
        } )

        this.lights.setDebug()
        this.fox.setDebug()
    }
}